import { Action } from '@ngrx/store';
import { HttpAccountFilters } from '@account-users/account/models/IAccount';
import { ISectionMap } from '@account-users/account/models/Audience';

export enum AccountSectionsActionTypes {
  LoadSections = '[Accounts] Load Sections',
  LoadSectionsSuccess = '[Accounts] Load Sections Success',
  LoadSectionsFailure = '[Accounts] Load Sections Failure',
}

export class LoadSections implements Action {
  readonly type = AccountSectionsActionTypes.LoadSections;
  constructor(
    public payload: { accountId: string; filters?: HttpAccountFilters },
  ) {}
}

export class LoadSectionsFailure implements Action {
  readonly type = AccountSectionsActionTypes.LoadSectionsFailure;
}

export class LoadSectionsSuccess implements Action {
  readonly type = AccountSectionsActionTypes.LoadSectionsSuccess;
  constructor(public payload: ISectionMap) {}
}

export type AccountSectionsAction =
  | LoadSections
  | LoadSectionsFailure
  | LoadSectionsSuccess;
